import {
  SET_COUNTRY_DROPDOWN,
  SET_BRANCH_VALUES,
  SET_RESULT_MESSAGE,
  SET_USER_DETAIL,
    SET_USER_BRANCH_DETAIL,
    SET_USER_DETAIL_EXTERNAL,
    SET_BRANCH
} from './types';
 
const initialState = {
  loading:false,
  Branchvalues: [],
  countryDropdown: [],
  userDetails:{},
  resultMessage:'',
  titleDetails:[],
  departmentDetails:[],
  getUserDetails:{},
  showUserProfile: false,
  userProfileDetails: {},
  externalUserData: []
}

const reducer = (state = initialState, action:any) => {
  switch (action.type) {
    case SET_COUNTRY_DROPDOWN:
      const countryDropdown = action.countryDropdown;
      return {
        ...state, countryDropdown
      };
      case SET_USER_DETAIL:
        const getUserDetails = action.value;
        return {
          ...state, getUserDetails
        };
      case SET_BRANCH_VALUES:
        return {
          ...state,
          Branchvalues: action.value
      }
      case SET_BRANCH:
      return {
        ...state,
        BranchList: action.payload,
      };
      case SET_USER_BRANCH_DETAIL:
          return {
              ...state,
              userProfileDetails: action.value
          }
      case SET_RESULT_MESSAGE:
        return {
          ...state,
         resultMessage: action.value
      }
      case SET_USER_DETAIL_EXTERNAL:
        return {
          ...state,
          externalUserData: action.value
      }
    default:
      return state
  }
}

export default reducer
